import { API, DOMAIN } from '@autopass-web/domain';
import HttpClient from '../http-client';

class ContactHttpClient extends HttpClient {
  constructor(props: any) {
    super(props);
    this.apiConfig = DOMAIN.API_URL[API.CONTACT];
    this.httpClient = this.createHttpClient({
      headers: this.apiConfig.headers,
      baseUrl: this.apiConfig.baseUrl,
    });

    this.httpClient.interceptors.request.use((value: any) =>
      this.interceptRequest(value),
    );
    this.httpClient.interceptors.response.use(
      (value: any) => this.interceptResponseResult(value),
      (error: any) => this.interceptResponseError(error, this.httpClient),
    );
  }

  fetchIssues = () => {
    return this.get('tickets/types');
  };

  fetchPoisByKeywords = ({ lat = '', lng = '', keyword = '' }) => {
    const params = new URLSearchParams({ lat, lng, keyword });
    return this.get(`pois?${params.toString()}`);
  };

  uploadFile = (file: any) => this.post('files', file);

  deleteFile = (token: string) => this.delete(`files?token=${token}`);

  sendIssues = ({
    typeId,
    userId,
    distributorId,
    orderId,
    customerName,
    customerEmail,
    customerMobile,
    fields,
    description,
    files,
  }: any) => {
    const data = {
      type_id: typeId,
      distributor_id: distributorId,
      order_id: orderId,
      user_id: userId,
      customer_name: customerName,
      customer_email: customerEmail,
      customer_mobile: customerMobile,
      fields,
      description,
      attachments: files,
    };

    return this.post('tickets', JSON.stringify(data), {
      headers: { 'content-type': 'application/json' },
    });
  };
}

export default ContactHttpClient;
